<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Critical Permissions</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm" iconPos="right" />
                </div>
            </div>
            <div class="card">
                <div>
                    <span class="subtext p-mt-2 p-text-capitalize">
                        <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                    </span>
                </div>
                <div style="position: relative" v-if="!showLoader">
                    <div class="p-py-4 p-px-3">
                        <div class="p-fluid p-formgrid p-grid">
                            <DataTable :value="permissions" :lazy="true" :paginator="false" :rows="30"
                                :totalRecords="totalRecords" :loading="loading" @page="onPage" class="p-datatable-users"
                                data-key="value" :rowHover="true"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                                <template #empty> No data found. </template>
                                <template #loading> Loading data. Please wait... </template>
                                <Column field="value" header="Sr." headerStyle="width: 4%">
                                    <template #body="{ index }">
                                        {{ index + 1 }}
                                    </template>
                                </Column>
                                <Column header="Permissions" headerStyle="width: 37%">
                                    <template #body="{ data }">
                                        <div>{{ data.label }}</div>
                                    </template>
                                </Column>
                                <Column header="Admin Users" headerStyle="width: 39%">
                                    <template #body="{ index }">
                                        <MultiSelect v-model="admin_user_fks[index]" :options="adminUsersList"
                                            optionValue="value" optionLabel="label" placeholder="Select Users"
                                            :filter="false" class="multiselect-custom p-text-capitalize" appendTo="body"
                                            @change="updateModel(admin_user_fks[index], index)"></MultiSelect>
                                    </template>
                                </Column>
                                <Column header="Action" headerStyle="width: 15%">
                                    <template #body="{ data, index }">
                                        <div>
                                            <Button label="Allow"
                                                class="p-button-text"
                                                @click="assignPermission(data.key, index)"
                                                style="width: 50px" :disabled="!admin_user_fks[index]" />
                                            <Button
                                                label="Remove" class="p-button-text"
                                                :disabled="!admin_user_fks[index] || !serverStatus[index]"
                @click="removePermission(data.key, index)"
                                                style="width: 65px" />
                                                </div>
                                    </template>
                                </Column>
                            </DataTable>
                            <Toast />
                        </div>
                    </div>
                </div>
                <div v-if="showLoader" style="height: 390px; position: relative">
                    <div class="custom-modal-spinner-loader">
                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from '../../service/ApiService';
import { useRoute } from 'vue-router';
import router from '@/router';

export default {
    data() {
        return {
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            localAdminName: '',
            adminUsersList: [],
            admin_user_fks: [],
            routeParam: 0,
            disabledFlag: false,
            serverStatus: [],
            permissions: [
                { value: '1', label: 'Allow to display Mobile Number', key: 'ad39' },
                { value: '2', label: 'Allow to display Email ID', key: 'ad40' },
                { value: '3', label: 'Allow to modify Law User`s Professional Information', key: 'ad42' },
                // { value: '4', label: 'Allow to display Driving License', key: 'allow_to_display_driving_licence_number' },
                // { value: '5', label: 'Allow to display PAN Number', key: 'allow_to_display_pan_number' },
                // { value: '6', label: 'Allow to display Passport Number', key: 'allow_to_display_passport_number' },
                // { value: '7', label: 'Allow to display Voter Number', key: 'allow_to_display_voter_number' },
                // { value: '8', label: 'Allow to modify Admin User`s Professional Information', key: 'edit_admin_user' },
                // { value: '9', label: 'Allow to display GST Number', key: 'allow_to_display_GST_number' },
                // { value: '10', label: 'Allow making calls to the Tenant', key: 'allow_to_call_for_tenant' },
                // { value: '11', label: 'Allow making calls to the Employee', key: 'allow_to_call_for_employee' },
                // { value: '12', label: 'Allow to display Tenant information', key: 'allow_to_display_tenant_information' },
                // { value: '13', label: 'Allow displaying Employee information', key: 'allow_to_display_employee_information' },
                // { value: '14', label: 'Allow listening to Tenant call recordings', key: 'allow_to_listen_tenant_call_recording' },
                // { value: '15', label: 'Allow listening to Employee call recordings', key: 'allow_to_listen_employee_call_recording' }
            ]
        };
    },

    ApiService: null,
    interval: null,
    created() {
        this.loading = true;
        this.ApiService = new ApiService();
        const route = useRoute();
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.fetchAdminUsers();
        this.fetchPermissions();
    },
    methods: {
        async fetchAdminUsers() {
            try {
                const res = await this.ApiService.getAdminUsersOnly({ clientId: this.routeParam });
                this.adminUsersList = res.data;
            } catch (err) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: err.message, life: 3000 });
            }
        },

        async fetchPermissions() {
            try {
                const res = await this.ApiService.getAdminUserCriticalPermissions({ clientId: this.routeParam });

                this.permissions.forEach((perm, i) => {
                    const data = res[perm.key];
                    if (Array.isArray(data) && data.length > 0) {
                        const ids = data.map(u => u.ad1);
                        this.admin_user_fks[i] = ids;
                        this.serverStatus[i] = ids;
                    } else {
                        this.admin_user_fks[i] = null;
                        this.serverStatus[i] = null;
                    }
                });

                this.loading = false;
            } catch (err) {
                this.loading = false;
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch permissions.', life: 3000 });
            }
        },

        async assignPermission(key, index) {
            const selected = this.admin_user_fks[index];
            if (!selected || selected.length === 0) {
                return this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please select Users', life: 3000 });
            }

            const payload = {
                clientId: this.routeParam,
                key: key,
                user_fks: selected.join(',')
            };

            this.loading = true;
            const res = await this.ApiService.updateAdminUserCriticalPermissions(payload);
            this.loading = false;

            if (res.success) {
                this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Permission Applied.', life: 3000 });
                this.fetchPermissions();
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.', life: 3000 });
            }
        },

        async removePermission(key) {
            const payload = {
                clientId: this.routeParam,
                key: key,
                remove_flag: 1
            };

            this.loading = true;
            const res = await this.ApiService.updateAdminUserCriticalPermissions(payload);
            this.loading = false;

            if (res.success) {
                this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Permission Removed.', life: 3000 });
                this.fetchPermissions();
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.', life: 3000 });
            }
        },
        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },

            });
        },

        goToPrevious() {
            router.push({
                name: "add-debit",
                params: { adminSubId: this.routeParam },
            });
        },
        goToNext() {
            router.push({
                name: "template-actions",
                params: { adminSubId: this.routeParam },

            });
        },
    }

};
</script>

<style scoped></style>
